export default [
  "box",
  "table",
  "trow",
  "tcol",
  "separator",
  "icon",
  "text",
  "textField",
  "textarea",
  "select",
  "multiSelect",
  "checkbox",
  "radioGroup",
  "radio",
  "chipGroup",
  "chip",
  "datePicker",
  "timeIntervalSelect",
  "imageUploader",
];
